import { captureException } from "@sentry/react"
import { type FC, useEffect } from "react"
import { type ErrorResponse, useRouteError } from "react-router"

export const ErrorPage: FC = () => {
  const error = useRouteError()

  useEffect(() => {
    captureException(error, { level: "fatal" })
  }, [error])

  return (
    <main className="h-screen flex flex-col items-center justify-center gap-2">
      <h1 className="text-4xl">Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p className="text-muted-foreground">
        <i>{(error as ErrorResponse)?.statusText || (error as Error)?.message}</i>
      </p>
    </main>
  )
}
